import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Dashboard, DefaultDashboard } from "../../../Constant";
import AddProduct from "./AddProduct";
import YourCurrentBalance from "./YourCurrentBalance";
import WeeklyVisitors from "./WeeklyVisitors";
import TotalDetails from "./TotalDetails";
import SalesSummary from "./SalesSummary";
import TrackOrder from "./TrackOrder";
import SellingProduct from "./SellingProduct";

const DefaultDashboardContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={DefaultDashboard} parent={Dashboard} title={DefaultDashboard} />
      <Container fluid className="default-dashboard">
        <Row>
          <AddProduct />
          <YourCurrentBalance/>
          <WeeklyVisitors/>
          <TotalDetails/>
          <SellingProduct/>
          <SalesSummary/>
          <TrackOrder/>
        </Row>
      </Container>
    </>
  );
};

export default DefaultDashboardContainer;
